﻿import {isNullOrEmpty, translation} from "@2d-front-monorepo/core";
import {ErrorMessage, RemoteDataStatus, Select, useRemoteData} from "@2d-front-monorepo/design-library";
import {PermitId, Permits, VehicleId, Vehicles} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";

import {JSX, SyntheticEvent, useState, useMemo, useCallback} from "react";
import {useSearchParams} from "react-router";
import PermitsInlineLoading from "../../components/PermitsInlineLoading";
import Registrations from "../../customers/Registrations";
import {getHttpClient} from "../../hooks/getHttpClient";
import {usePermits} from "../../hooks/usePermits";

export default function CreateVehicle(): JSX.Element {
	const [searchParams] = useSearchParams();
	const permitsState = usePermits();

	const permitId = searchParams.get("permitId") as PermitId;
	const permit = isNullOrEmpty(permitId) ? undefined : Permits.find(permitsState, permitId);

	const vehicles = useMemo(() => permit == null ? [] : Vehicles.getChanged(permitsState, permit.vehicles), [permit, permitsState]);
	const [vehicleId, setVehicleId] = useState(() => vehicles.length === 0 ? undefined : vehicles[0].original.id);

	const plates = useMemo(() => vehicles.map(function (vehicle) {
		const v = Vehicles.get(permitsState, vehicle.original.id);
		return {label: v.plate, value: v.id as string};
	}), [vehicles]);

	const onVehicleChange = useCallback((evt: SyntheticEvent<HTMLSelectElement>) => {
		setVehicleId(evt.currentTarget.value as VehicleId);
	}, [setVehicleId]);

	const {data, status, error} = useRemoteData(() => {
		if (vehicleId == null) {
			return Promise.resolve(undefined);
		}

		return getHttpClient().permits.getVehicleBehavior(permitId, vehicleId);
	}, [vehicleId]);

	if (status === RemoteDataStatus.Loading) {
		return <PermitsInlineLoading/>;
	}

	if (status === RemoteDataStatus.Error) {
		return <ErrorMessage error={error}/>;
	}

	const vehicle = vehicleId == null ? undefined : Vehicles.get(permitsState, vehicleId);
	const useSelector = plates.length > 1;

	const EditComponent = Registrations.getCreateVehicle();
	return (
		<EditComponent permits={permitsState} holder={permitsState} permit={permit} vehicle={vehicle} behavior={data}>
			{useSelector && <Select label={translation(PermitTranslations.new_vehicle__old_vehicle__label)} items={plates} name={"oldVehicleId"} required={true} value={vehicleId}
                                    onChange={onVehicleChange}/>}
		</EditComponent>
	);
}
